import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { clearDemoSession, seedDemoSession } from '../../demo/core';
import { demoOrganizationFor, ensureDemoData } from '../../demo/data';

/** Where the demo lands: the Supply page of the recycler. */
const HOME = '/supply';

/**
 * Public entry for the market demo (/demo/recycler). Market is recycler-only, so
 * the persona is fixed; '/demo/outlet' redirects here and anything else goes to
 * /login. Seeds a demo session in this tab, then reloads into the app so it
 * boots through initAuth on the demo token.
 */
const DemoEntry: React.FC = () => {
  const { persona } = useParams();

  useEffect(() => {
    if (persona !== 'recycler') {
      window.location.replace('/login');
      return;
    }
    clearDemoSession();
    ensureDemoData();
    seedDemoSession('recycler', { ...demoOrganizationFor('recycler') });
    window.location.replace(HOME);
  }, [persona]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        px: 2,
        textAlign: 'center',
        bgcolor: 'background.default',
      }}
    >
      <CircularProgress sx={{ color: '#2CB259' }} />
      <Typography variant="body1" sx={{ fontWeight: 600 }}>
        Preparing the Recyclee Market demo…
      </Typography>
      <Typography variant="body1" dir="rtl" sx={{ fontWeight: 600 }}>
        جارٍ تجهيز العرض التجريبي لمنصة ريسايكلي ماركت…
      </Typography>
    </Box>
  );
};

export default DemoEntry;
